<template>
  <div v-bind:class="{'view-mode':!editMode}"
       class="bet-card-container">
    <div v-bind:class="{'bets-card-overlay':isUpdatingBet}"
         class="bet-card">
      <div class="bet-card-teams">
        <span
          v-bind:class="[betData.betStatus =='Matched' ? 'bet-card-team-status-state-matched' : 'bet-card-team-status-state-unmatched']"
          class="bet-card-team-status-state">
          <span class="bet-card-team-status">{{$t(`bets.openBets.status`)}}</span>{{$t(`bets.openBets.${betData.betStatus}`)}} {{betData.keepBetOnLive? $t(`bets.openBets.keepInPlayTag`):''}}
        </span>
      </div>
      <div class="bet-card-result">
        <span class="bet-card-result-team"><span
          class="bet-card-result-text">{{betData.market}}</span>{{betData.runner.charAt(0).toUpperCase() + betData.runner.slice(1)}}</span>
      </div>
      <div class="bet-card-cells">
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             class="bet-card-cell bet-card-odds">
              <span v-if="betData.betType ==='Lay'">{{ $t('bets.lay') |
              removeDiacriticsFromUppercase}}</span>
          <span v-if="betData.betType ==='Back'">{{ $t('bets.back') |
              removeDiacriticsFromUppercase}}</span>
          <OddsInput v-if="!betEditInstance"
                     @click.native="enableEditMode"
                     :betData=" betData"
                     :betPosition="betPosition"
                     :type=type
                     :edit-mode="editMode"
                     inputSection="openBets"

          ></OddsInput>
          <OddsInput v-if="betEditInstance"
                     :betData="betEditInstance "
                     :betPosition="betPosition"
                     :type=type
                     :edit-mode="editMode"
                     inputSection="openBets"

          ></OddsInput>
        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             class="bet-card-cell">
          <span>{{ $t('bets.stake') |
              removeDiacriticsFromUppercase}}</span>
          <StakeInput v-if="typeof betEditInstance === 'undefined'"
                      :betData="betData"
                      :betPosition="betPosition"
                      @click.native="removeErrorMessageForStake(betData.runnerId);enableEditMode();"
                      :type=type
                      :alertCase=alertCase
                      :edit-mode="editMode"
                      inputSection="openBets"


          ></StakeInput>
          <StakeInput v-if="typeof betEditInstance !== 'undefined'"
                      :betData="betEditInstance "
                      :betPosition="betPosition"
                      @click.native="removeErrorMessageForStake(betData.runnerId)"
                      :type=type
                      :alertCase=alertCase
                      :edit-mode="editMode"
                      inputSection="openBets"


          ></StakeInput>

        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             v-if="betData.betType === 'Back'"
             class="bet-card-cell bet-card-profit">
          <span>{{ $t('bets.profit') |
              removeDiacriticsFromUppercase}}</span>
          <div class="bet-card-profit-value" v-if="profitForBet >=0">
            {{this.userCurrency}}{{profitForBet | numberWithCommas}}
          </div>
          <div class="bet-card-profit-value" v-if="profitForBet <0">

          </div>
        </div>
        <div v-bind:class="[type === 'back' ? 'bet-card-cell-back':'bet-card-cell-lay']"
             v-if="betData.betType === 'Lay'"
             class="bet-card-cell bet-card-profit">
          <span>{{ $t('bets.liability') |
              removeDiacriticsFromUppercase}}</span>
          <div class="bet-card-profit-value" v-if="liabilityForBet >=0">
            {{this.userCurrency}}{{liabilityForBet | numberWithCommas}}
          </div>
          <div class="bet-card-profit-value" v-if="liabilityForBet <0">
          </div>
        </div>
        <div class="bet-card-cell bet-card-delete"
             v-if="betData.betStatus === 'Unmatched' && !editMode">
          <v-icon @click.stop="showDeleteMode">krypt-delete</v-icon>
        </div>
      </div>
      <transition name="slide">
        <div v-if="alertCase !== ''" class="bet-alert"
             v-bind:class="[{
      'error-message':(betMessage.type==='error' || betMessage.type==='' ),
      'success-message':betMessage.type==='success',
      'warning-message':betMessage.type==='warning',
      }]">
          <transition name="fade">
            <span class="bet-alert-text">{{alertCase}}</span>
          </transition>
        </div>
      </transition>
      <div v-bind:class="{'edit-controls--active':editMode}"
           class="edit-controls">
        <div class="bet-card-reset" @click.stop="disableEditMode">
          <span>{{$t(`bets.openBets.reset`) | removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="bet-card-update" @click.stop="updateBet">
          <v-icon v-show="isUpdatingBet">krypt-loader</v-icon>
          <span v-bind:class="{'bet-card-update-text':isUpdatingBet}">{{$t(`bets.openBets.update`) | removeDiacriticsFromUppercase}}</span>
        </div>
      </div>
      <div v-bind:class="{'delete-controls--active':deleteMode}"
           class="edit-controls">
        <div class="bet-card-delete-cancel" @click.stop="hideDeleteMode">
          <span>{{$t(`bets.openBets.no`) | removeDiacriticsFromUppercase}}</span>
        </div>
        <div class="bet-card-delete-confirm" @click.stop="removeBet">
          <v-icon v-show="isDeletingBet">krypt-loader</v-icon>

          <span v-bind:class="{'bet-card-delete-text':isDeletingBet}">{{$t(`bets.openBets.yes`) | removeDiacriticsFromUppercase}}</span>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import OddsInput from '@/components/other/kryptOddsInput';
import StakeInput from '@/components/other/kryptStakesInput';
import DeleteIcon from '@/assets/utility/Delete.svg';
import Axios from 'axios';

export default {
  name: 'openBetCard',
  props: [
    'type',
    'betData',
    'betPosition',
  ],
  computed: {
    betMessage: function () {
      return this.$store.state.bets.active.betMessages[this.betData.id] || {
        type: '',
        message: '',
        messageId: ''
      };
    },
    isUpdatingBet: function () {
      return this.$store.state.bets.active.betsBeingUpdated[this.betData.id]?.isUpdating;
    },
    isDeletingBet: function () {
      return this.$store.state.bets.active.betsBeingDeleted[this.betData.id]?.isDeleting;
    },
    betEditInstance: function () {
      return this.$store.state.bets.active.betsBeingUpdated[this.betData.id];
    },
    profitForBet: function () {
      if (this.editMode && typeof this.betEditInstance !== 'undefined') {
        return `${((Number(this.betEditInstance.odds) - 1) * Number(this.betEditInstance.stake)).toFixed(2)}`;
      } else {
        return `${((Number(this.betData.odds) - 1) * Number(this.betData.stake)).toFixed(2)}`;
      }
    },
    minimumLiability: function () {
      return this.$store.state.user.minimumLiability;
    },
    liabilityForBet: function () {
      if (this.editMode && typeof this.betEditInstance !== 'undefined') {
        if (this.betEditInstance?.betType === 'Lay') {
          return (this.betEditInstance.stake * (Number(this.betEditInstance.odds) - 1)) !== 0 ? (this.betEditInstance.stake * (Number(this.betEditInstance.odds) - 1)).toFixed(2) : '0';
        } else {
          return this.betEditInstance.stake;
        }
      } else {
        if (this.betData?.betType === 'Lay') {
          return (this.betData.stake * (Number(this.betData.odds) - 1)) !== 0 ? (this.betData.stake * (Number(this.betData.odds) - 1)).toFixed(2) : '0';
        } else {
          return this.betData.stake;
        }
      }

    },
    initialLiability: function () {
      if (this.betData?.betType === 'Lay') {
        return (this.betData.stake * (Number(this.betData.odds) - 1)) !== 0 ? (this.betData.stake * (Number(this.betData.odds) - 1)).toFixed(2) : '0';
      } else {
        return this.betData.stake;
      }
    },
    userCurrency: function () {
      return this.$store.state.userCurrency;
    },
    userBalance: function () {
      return this.$store.state.user.info.balance;
    },
    alertCase: function () {
      let message = '';
      if (this.editMode === true) {
        if (this.runnerErrorMessage !== '') {
          message = this.runnerErrorMessage;
        } else if (this.marketErrorMessage !== '') {
          message = this.marketErrorMessage;
        } else {
          message = this.betMessage.message || '';
        }
      }
      if (this.deleteMode === true) {
        message = this.betMessage.message || '';
      }
      if (this.betMessage.messageId === 'betUpdateSuccessful') {
        message = this.betMessage.message || '';
      }
      return message;

    },
    market: function () {
      return this.$store.state.markets[this.betData.eventId]?.markets[this.betData.marketId];
    },
    betRunner: function () {
      return (this.market ? this.market.runners.find((runner) => {
        return runner.id === this.betData.runnerId;
      }) : '');
    },
    marketStatus: function () {
      return this.market ? this.market.status : '-';
    },
    runnerIsActive: function () {
      return this.betRunner ? this.betRunner.active : false;
    },
    selectedSection: function () {
      return this.$store.state.bets.activeSection;
    },
    isInLockdown:function (){
      return this.$store.state.isInLockdown;
    }
  },
  watch: {

    marketStatus: function (marketStatus) {
      console.log(marketStatus);
      if (marketStatus === 'INACTIVE' || marketStatus === '-') {
        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'marketStatusMesage',
        //   message: this.$t('bets.errorMessages.marketInactive')
        // });
        this.marketErrorMessage = this.$t('bets.errorMessages.marketInactive');
        this.isValidForUpdate = false;

      } else if (marketStatus === 'SUSPENDED') {
        this.marketErrorMessage = this.$t('bets.errorMessages.marketSuspended');
        this.isValidForUpdate = false;

        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'marketStatusMesage',
        //   message: this.$t('bets.errorMessages.marketSuspended')
        // });

      } else {
        this.marketErrorMessage = '';
        this.isValidForUpdate = true;

      }
      // if (marketStatus === '-') {
      //   this.removeBet();
      // }
    },
    runnerIsActive: function (runnerIsActive) {
      console.log(runnerIsActive);
      if (runnerIsActive === false) {
        // this.$store.commit('addBetMessage', {
        //   id: this.betData.runnerId,
        //   messageType: 'runnerStatusMessage',
        //   message: this.$t('bets.errorMessages.marketInactive')
        // });
        this.runnerErrorMessage = this.$t('bets.errorMessages.runnerInactive');
        this.isValidForUpdate = false;

      } else {
        this.runnerErrorMessage = '';
        this.isValidForUpdate = true;

      }
    },
    isUpdatingBet: function (newValue, oldValue) {
      if (newValue === false && (this.betMessage.messageId === 'betUpdateSuccessful' || this.betMessage.messageId === 'networkConnectionError')) {
        this.disableEditMode();
      }
      ;
    }
  },
  data: function () {
    return {
      DeleteIcon: DeleteIcon,
      marketErrorMessage: '',
      runnerErrorMessage: '',
      isValidForUpdate: true,
      editMode: false,
      deleteMode: false
    };
  },
  methods: {
    updateBet: function () {
      let calculatedLiability = 0;
      if (this.betEditInstance.stake === 0 || this.betEditInstance.stake === '') {
        this.$store.commit('setOpenBetMessage', {
          id: this.betData.id,
          type: 'error',
          messageType: 'temporaryOnClickRemove',
          message:
            this.$t('bets.errorMessages.noStake')
        });

      } else if (this.liabilityForBet < this.minimumLiability) {
        this.$store.commit('setOpenBetMessage', {
          id: this.betData.id,
          messageType: 'temporaryOnClickRemove',
          type: 'error',
          message:
            this.$t('bets.errorMessages.liabilityTooLow') + ` (${this.userCurrency}${this.$options.filters.numberWithCommas(this.minimumLiability)}).`
        });

      } else if (window.navigator.onLine) {
        if(!this.isInLockdown){
          this.$store.commit('setIsUpdatingBet', {id: this.betData.id, isUpdating: true})
          console.log(process.env.VUE_APP_BACKEND_URL);
          Axios.post(process.env.VUE_APP_BACKEND_URL + `/Bets/CalculateLiabilityForUpdateBets`,
            [{
              refId: '0',
              betId: this.betData.id,
              odds: Number(this.betEditInstance.odds),
              stake: Number(this.betEditInstance.stake)
            }], {
              timeout: 20 * 1000
            })
            .then(function (response) {
              calculatedLiability = response.data.liability;
              this.$store.commit('setUserBalance', response.data.userBalance);
              if (this.userBalance + calculatedLiability >= 0) {
                this.$store.dispatch('updateBet', {
                  refId: '0',
                  betId: this.betData.id,
                  odds: this.betEditInstance.odds,
                  stake: this.betEditInstance.stake
                });
              } else {
                this.$store.commit('setIsUpdatingBet', {id: this.betData.id, isUpdating: false});
                this.$store.commit('setOpenBetMessage', {
                  id: this.betData.id,
                  messageType: 'temporaryOnClickRemove',
                  type: 'error',
                  message:
                    this.$t('bets.errorMessages.liabilityTooHighForBet') + ` (${this.userCurrency}${this.$options.filters.numberWithCommas(this.userBalance)}).`
                });
              }
            }.bind(this))
            .catch(function (error) {
              // handle error
              console.log(error);
              this.$store.commit('setIsUpdatingBet', {id: this.betData.id, isUpdating: false});
              this.$store.commit('setOpenBetMessage', {
                id: this.betData.id,
                type: 'error',
                messageId: error.code === 'ECONNABORTED' ? 'networkConnectionError' : 'unexpectedError',
                message: error.code === 'ECONNABORTED' ? this.$t('bets.openBets.networkConnectionError') : this.$t('bets.openBets.unexpectedError'),
                messageType: 'temporaryOnClickRemove'
              });
            }.bind(this));
        } else{
          this.$store.commit('setOpenBetMessage', {
            id: this.betData.id,
            type: 'error',
            message: this.$t('bets.openBets.backendCodes.EmergencyLocked'),
            messageType: "temporaryOnClickRemove"
          });
        }

      } else {
        this.$store.commit('setOpenBetMessage', {
          id: this.betData.id,
          type: 'error',
          message: this.$t('bets.openBets.noNetwork'),
          messageType: "temporaryOnClickRemove"
        });
      }

    },
    removeErrorMessageForStake: function (betId) {
      this.$store.commit('removeOpenBetErrorMessageForStake', betId);
    },
    showDeleteMode: function () {
      if (!this.editMode) {
        this.$store.commit('setOpenBetMessage', {
          type: 'warning',
          id: this.betData.id,
          message: this.$t('bets.openBets.cancellationText'),
          messageType: 'hiddenByComponent'
        });
        this.deleteMode = true;
      }

    },
    hideDeleteMode: function () {
      this.$store.commit('setOpenBetMessage', {
        type: 'warning',
        id: this.betData.id,
        message: '',
        messageType: ''
      });

      this.deleteMode = false;

    },
    removeBet: function () {
      this.$store.commit('setIsDeletingBet',{
        id:this.betData.id,
        isDeletingBet:true
      })
      this.$store.dispatch('deleteBet', {
        refId: '0',
        betId: this.betData.id
      });
      // this.deleteMode = false
    },
    enableEditMode: function () {
      if (!this.deleteMode && this.betData.betStatus === 'Unmatched') {
        this.$store.commit('setBetBeingUpdated', this.betData);
        this.editMode = true;
      }
    },
    disableEditMode: function () {
      if (!this.isUpdatingBet) {
        this.$store.commit('removeBetBeingUpdated', this.betData);
        this.editMode = false;
      }

    },
  },
  components: {
    OddsInput,
    StakeInput
  },
  mounted() {
    if (this.marketStatus === 'INACTIVE' || this.marketStatus === '-') {

      this.marketErrorMessage = this.$t('bets.errorMessages.marketInactive');
      this.isValidForUpdate = false;

    } else if (this.marketStatus === 'SUSPENDED') {
      this.marketErrorMessage = this.$t('bets.errorMessages.marketSuspended');
      this.isValidForUpdate = false;

    } else {
      this.marketErrorMessage = '';
      this.isValidForUpdate = true;

    }
    if (this.runnerIsActive === false) {
      this.runnerErrorMessage = this.$t('bets.errorMessages.runnerInactive');
      this.isValidForUpdate = false;

    } else {
      this.runnerErrorMessage = '';
      this.isValidForUpdate = true;
    }
    if (this.betEditInstance) {
      this.editMode = true;
    }
  }
};
</script>

<style scoped>

  .bet-card {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    padding: 8px 8px 0 8px;
    position: relative;
  }

  .bet-card-cells {
    display: flex;
    flex-direction: row;
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
    padding-bottom: 8px;
  }

  .bet-card-cell {
    display: flex;
    flex-direction: column;
    margin-right: 8px;
    min-width: 80px;
    max-width: 80px;
  }

  .bet-card-cell > span {
    font-size: 10px;
    line-height: 14px;
    font-weight: bold;
    margin-bottom: 1px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .bet-card-cell-back > span {
    color: var(--superman);
  }

  .bet-card-cell-lay > span {
    color: var(--lex-luthor);
  }

  .bet-card-teams {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  }

  .bet-card-team-status-state {
    /* display: flex;
    align-items: center; */
    font-size: 12px;
    line-height: 16px;
    font-weight: bold;
  }

  .bet-card-team-status-state-unmatched {
    color: var(--cyborg);
  }

  .bet-card-team-status-state-matched {
    color: var(--superman);
  }

  .bet-card-team-status {
    /* display: flex;
    align-items: center; */
    font-size: 12px;
    line-height: 16px;
    color: var(--grey-500);
    margin-right: 6px;
    font-weight: normal;
  }

  .bet-card-result {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-bottom: 8px;
  }

  .bet-card-result-text {
    font-size: 14px;
    line-height: 19px;
    color: var(--grey-500);
    font-weight: normal;
    margin-right: 8px;
  }

  .bet-card-result-text::first-letter,
  .bet-card-result-team::first-letter,
  .bet-card-teams span::first-letter {
    text-transform: uppercase;
  }

  .bet-card-result-team {
    font-size: 14px;
    line-height: 19px;
    color: var(--grey-900);
    font-weight: bold;
  }

  .bet-card-delete {
    justify-content: flex-end;
    align-items: flex-end;
    min-width: 24px;
    max-width: 24px;
    margin-right: 0 !important;
    margin-left: 8px !important;
  }

  .bet-card-delete button {
    color: var(--grey-400);
    padding: 3px 0;
  }

  .bet-card-delete button:hover {
    color: var(--grey-600);
  }

  .bet-card-delete button:focus:after {
    opacity: 0 !important;
  }

  .bet-card-profit {
    flex-grow: 1;
    min-width: 0 !important;
    max-width: calc(100% - 176px) !important;
    overflow: hidden;
    margin-right: 0 !important;
  }

  .bet-card-profit > span {
    max-width: 80px;
  }

  .bet-card-profit-value {
    padding: 6px 4px;
    background-color: var(--grey-100);
    border-radius: 6px;
    overflow: hidden;
    width: max-content;
    max-width: 100%;
    text-align: center;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    align-items: center;
    font-size: 12px;
    font-weight: bold;
    line-height: 16px;
    color: var(--primary);
    text-align: center;
    width: max-content;
    height: 28px;
    min-width: 80px;
  }

  .bet-card-odds {
    height: 100%;
  }

  .bet-card-stake {
    min-width: 80px !important;
    max-width: 80px !important;
  }

  .bet-alert {
    max-height: 64px;
    transition: max-height 0.5s ease-in-out;
    display: flex;
    align-items: center;
    background-color: var(--cyborg-light);
    clip-path: inset(0%);
    margin-left: -8px;
    width: calc(100% + 16px);
  }

  .bet-alert-text {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    padding: 8px;
  }

  .error-message {
    background-color: var(--cyborg-light);
  }

  .success-message {
    background-color: var(--aquaman-light);
  }

  .warning-message {
    background-color: var(--wonder-woman-light);

  }

  .error-message > span {

    background-color: var(--cyborg-light);
    color: var(--cyborg);
  }

  .success-message > span {
    background-color: var(--aquaman-light);
    color: var(--aquaman);
  }

  .warning-message > span {
    background-color: var(--wonder-woman-light);

    color: var(--wonder-woman);
  }

  .edit-controls {
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    width: 100%;
    max-height: 0;
    transition: all 0.5s ease-in-out;
    clip-path: inset(0);
    overflow: hidden;
  }

  .edit-controls--active {
    max-height: 48px;
    padding: 8px 0 8px 0;
  }

  .delete-controls--active {
    max-height: 48px;
    padding: 8px 0 8px 0;
  }

  .bet-alert ~ .edit-controls--active {
    padding: 8px 0 8px 0;
  }

  .bet-alert ~ .delete-controls--active {
    padding: 8px 0 8px 0;
  }

  .bet-card-reset {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
    transition: color 0.2s ease-in-out;
  }

  .bet-card-delete-cancel {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    cursor: pointer;
  }

  .bet-card-reset > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
    text-transform: uppercase;
    transition: color 0.2s ease-in-out;
  }

  .bet-card:not(.bets-card-overlay) .bet-card-reset:hover > span {
    color: var(--grey-500);
  }

  .bet-card.bets-card-overlay .bet-card-reset {
    cursor: not-allowed;
  }

  .bet-card-delete-cancel > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    color: var(--grey-400);
    text-transform: uppercase;
  }

  .bet-card-delete-cancel:hover > span {
    color: var(--grey-500);
  }

  .bet-card-update {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background-color: var(--primary);
    cursor: pointer;
    border-radius: 6px;
    margin-left: 8px;
  }

  .bet-card-delete-confirm {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background-color: var(--primary);
    cursor: pointer;
    border-radius: 6px;
    margin-left: 8px;
  }

  .bet-card-delete-confirm:hover {
    background-color: var(--primary-state);
  }

  .bet-card-update > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;
    text-transform: uppercase;
  }

  .bet-card-delete-confirm > span {
    font-weight: bold;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: center;
    color: white;
    text-transform: uppercase;
  }

  .bet-card:not(.bets-card-overlay) .bet-card-update:hover {
    background-color: var(--primary-state);
  }

  .bet-card-update > .v-icon {
    font-size: 12px;
    line-height: 16px;
    animation: spin 1s infinite linear;
  }

  .bet-card-delete-confirm > .v-icon {
    font-size: 12px;
    line-height: 16px;
    animation: spin 1s infinite linear;
  }

  .bets-card-overlay:after {
    display: flex;
    content: "";
    position: absolute;
    width: 100%;
    height: calc(100% - 48px);
    background-color: white;
    z-index: 1;
    opacity: 0.6;
    top: 0;
    left: 0;
  }

  .bet-card-update-text {
    margin-left: 8px;
  }

  .bet-card-delete-text {
    margin-left: 8px;
  }

  .slide-enter-active, .slide-leave-active {
    transition: max-height 0.5s ease-in-out;
  }

  .slide-enter, .slide-leave-to {
    max-height: 0px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.5s ease-in-out;
  }

  .fade-enter, .fade-leave-to {
    opacity: 0;
  }

  /*Animations*/

  @keyframes spin {
    0% {
      transform: rotateZ(0)
    }
    100% {
      transform: rotateZ(360deg)
    }
  }


</style>
